(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'TrackingData';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();

        //navigation.type 1=reload, 2=back_forward
        var winPerf = window.performance;
        var winPerfNavEntryTypes = winPerf.getEntriesByType && winPerf.getEntriesByType("navigation").map(function (t) { return t.type });
        var updTrackingData = {
            BrowserNavigation: {
                Reload: (winPerf.navigation && winPerf.navigation.type == 1) || winPerfNavEntryTypes.indexOf('reload') >= 0,
                BackForward: (winPerf.navigation && winPerf.navigation.type == 2) || winPerfNavEntryTypes.indexOf('x-back_forward') >= 0
            }
        };

        //order tracking
        if (TrackingModel && TrackingModel.Order) {
            var isTest = LhApp.Context.Request.IsLocal && LhApp.Context.IsDebug;
            var completionServerReloaded = TrackingModel.Order.CompletionPageLoadCounter > 1; //if session lost page would not be reloaded. if that changes keep counter in db
            var browserReloadedOrBackForward = updTrackingData.BrowserNavigation.Reload || updTrackingData.BrowserNavigation.BackForward;
            updTrackingData.Order = {
                IsAlreadyTracked: isTest ? false : (completionServerReloaded || browserReloadedOrBackForward)
            };
        }
        //update TrackingData object
        LhApp.Function.Tracking.updateTrackingData(updTrackingData);

        //get new tracking model
        TrackingModel = LhApp.Function.Tracking.getTrackingModel();

        //initialize the tag manager or analytics
        if (TrackingModel && TrackingModel.GoogleTagManagerCode) {
            LhApp.Function.Tracking.InitGoogleTagManager();
        }
        if (TrackingModel && TrackingModel.GoogleAnalyticsCode && LhApp.Function.Tracking.canTrack('statisticCookies')) {
            LhApp.Function.Tracking.InitGoogleAnalytics();
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPageSuccess, TrackingScriptName, function (envelope) {
                var model = envelope.message.data.model;
                if (!window.TrackingData || !window.TrackingData.ProductListsData || envelope.message.data.type != 'productList' || !model.Items || model.Items.length < 1)
                    return;

                var list = model.SeoTitle;
                var lists = window.TrackingData.ProductListsData || [];
                var updatedProducts = [];

                if (list in lists) {
                    $.each(model.Items[0], function (idx, item) {
                        updatedProducts.push({
                            ProductId: '' + item.Id,
                            SkuId: '' + item.VariantId,
                            Name: item.Title,
                            Brand: item.Manufacturer,
                            Category: item.Category,
                            Path: item.Path,
                            Color: item.sel_color,
                            Size: item.sel_size,
                            PriceN: Math.round(item.Prices.Price.CurrentPriceN * 100) / 100,
                            PriceWithoutVatN: Math.round(item.Prices.Price.CurrentPriceWithoutVatN * 100) / 100,
                            List: list,
                            Position: lists[list].length + idx + 1,
                            Quantity: 1,
                            Image: item.Images.length > 0 ? item.Images[0].List : '',
                            Url: document.location.origin + item.Url,
                            Properties: []
                        });
                    });

                    if (updatedProducts.length > 0) {
                        lists[list] = $.merge(lists[list], updatedProducts);
                        Vendd.MessageBus.publishAsync(Vendd.Tracking, new Vendd.Tracking.Messages.ProductsUpdated(updatedProducts));
                    }
                }

            });

            Vendd.MessageBus.subscribe(Vendd.LazyProductList.Messages.LazyProductListSuccess, TrackingScriptName, function (envelope) {
                var model = envelope.message.data.model;
                if (!window.TrackingData || !model.Items || model.Items.length < 1 || !window.TrackingData.ProductListsData)
                    return;

                var list = model.SeoTitle;
                var lists = window.TrackingData.ProductListsData || [];
                var updatedProducts = [];

                $.each(model.Items[0], function (idx, item) {
                    updatedProducts.push({
                        ProductId: '' + item.Id,
                        SkuId: '' + item.VariantId,
                        Name: item.Title,
                        Brand: item.Manufacturer,
                        Category: item.Category,
                        Path: item.Path,
                        Color: item.sel_color,
                        Size: item.sel_size,
                        PriceN: Math.round(item.Prices.Price.CurrentPriceN * 100) / 100,
                        PriceWithoutVatN: Math.round(item.Prices.Price.CurrentPriceWithoutVatN * 100) / 100,
                        List: idx + 1,
                        Position: item.Index,
                        Quantity: 1,
                        Image: item.Images.length > 0 ? item.Images[0].List : '',
                        Url: document.location.origin + item.Url,
                        Properties: []
                    });
                });

                if (updatedProducts.length > 0) {

                    if (list in lists) {
                        window.TrackingData.ProductListsData[list] = $.merge(window.TrackingData.ProductListsData[list], updatedProducts);
                    } else {
                        window.TrackingData.ProductListsData[list] = updatedProducts;
                    }

                    Vendd.MessageBus.publishAsync(Vendd.Tracking, new Vendd.Tracking.Messages.ProductsUpdated(updatedProducts));
                }
            });
        }
    });
})();